import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface ButtonProps {
  text: string;
  icon?: IconDefinition;
  iconPosition?: "left" | "right";
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
}

const Button = ({
  text,
  icon,
  iconPosition = "right",
  onClick,
  className = "",
  type = "button",
  disabled = false,
}: ButtonProps) => {
  return (
    <div className="text-center">
      <button
        className={`button-lvf1 ${className}`}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {icon && iconPosition === "left" && (
          <FontAwesomeIcon icon={icon} className="icon left" />
        )}

        <span>{text}</span>

        {icon && iconPosition === "right" && (
          <FontAwesomeIcon icon={icon} className="icon right" />
        )}
      </button>
    </div>
  );
};

export default Button;
